import { ValidationErrorKey } from "../../validators/general-validation.";
import { swissMobileNumberValidator } from "../../validators/swiss-mobile-phone.validator";

import {
  FormFieldInput,
  HtmlInputMode,
  HtmlInputType,
  InputAutoCompleteAttribute,
  InputFormFieldInit,
} from "./base";

export class FormFieldInputMobileNumber extends FormFieldInput {
  constructor(init: InputFormFieldInit<FormFieldInputMobileNumber>) {
    init.inputType = HtmlInputType.TEL;
    init.validators = [swissMobileNumberValidator];
    init.autoComplete = InputAutoCompleteAttribute.TELEPHONE_NUMBER;
    init.inputMode = HtmlInputMode.TEL;
    super(init);
    this.addErrorMessages({
      [ValidationErrorKey.MOBILE_NUMBER]: $localize`Bitte geben Sie eine gültige Schweizer Mobilnummer ein.`,
    });
  }
}
